import {commonFailure, commonSuccess, getHeaders, sessionExpired} from "utils/Requests/Axios";
import {serialize} from "utils/Forms";
import axios from "axios";
import {isSolarPhotovoltaicByCaller, isSolarThermalByCaller, isThermalByCaller, isWaterByCaller} from "utils/Types";

export async function PlantsAdd(formData, successCallBack = () => {}, failCallBack = () => {}) {
    //complete progress bar
    window.progressReference.current.continuousStart();
    //success event when request is god
    const successHandler = async (response) => {
        //end the progress bar..
        window.progressReference.current.complete();
        //on success true
        if (response.data.success) {
            //show message of success sign up
            successCallBack('request.successfully');
        } else { //other events
            successCallBack('request.unknown');
        }
    }

    //fail event when request fail
    const failHandler = async (error) => {
        //end the progress bar..
        window.progressReference.current.complete();
        //for each error status
        if (error.response && error.response.status) {
            if (error.response.status === 429) {
                return failCallBack('request.max_requests');
            } else if (error.response.status === 400) {
                return failCallBack('request.bad_request');
            } else if (error.response.status === 403) {
                return failCallBack('request.unauthorized');
            } else if (error.response.status === 401) {
                return sessionExpired();
            }
        } //default fail error
        failCallBack('request.unknown');
    }

    //make a request
    await axios.post(
        `${global.config.api_url_v1}plant/reclaim`,
        serialize(formData),
        getHeaders(),
    ).then(async function (response) {
        await successHandler(response);
    }).catch(async function (error) {
        await failHandler(error);
    });
}

export function getUserPlants(config, successCallBack, failCallBack) {
    //default endpoint
    let endpoint = "";
    //set endpoint in function of caller device
    if(isSolarThermalByCaller(config)) {
        endpoint = "plant/solar/thermal/index";
    } else if(isSolarPhotovoltaicByCaller(config)) {
        endpoint = "plant/solar/photovoltaic/index";
    } else if(isThermalByCaller(config)) {
        endpoint = "plant/thermal/index";
    } else if(isWaterByCaller(config)) {
        endpoint = "plant/water/index";
    } else {
        return failCallBack();
    }

    //set limit...
    endpoint += '?limit=' + config.pagination.perPage;
    endpoint += '&offset=' + (config.pagination.perPage * (config.pagination.page - 1));
    endpoint += '&sortCol=' + config.sort.column;
    endpoint += '&sortDir=' + config.sort.direction;

    if(config.search) {
        endpoint += '&' + Object.keys(config.search).map(key => {
            if(!config.search[key] || (Array.isArray(config.search[key]) && config.search[key].length < 1)) {
                return '';
            } else {
                return key + '=' + config.search[key];
            }
        }).join('&');
    }

    axios.get( `${global.config.api_url_v1}${endpoint}`, getHeaders())
        .then(function (response) { commonSuccess(response, successCallBack); })
        .catch(function (error) { failCallBack(); commonFailure(error); });
}

export async function getUserPlantsForDelete(
    config,
    successCallBack,
    failCallBack
) {
    const endpoints = [
        {
            endpoint: "plant/solar/thermal/index",
            type: "solar_thermal",
            type_name: "Solar térmica"
        },
        {
            endpoint: "plant/solar/photovoltaic/index",
            type: "photovoltaic",
            type_name: "Fotovoltaica"
        },
        {
            endpoint: "plant/thermal/index",
            type: "thermal",
            type_name: "Temperatura"
        },
        {
            endpoint: "plant/water/index",
            type: "water",
            type_name: "Agua"
        }
    ];

    try {
        const requests = endpoints.map(item => {
            let url = `${item.endpoint}?limit=10000&offset=0`;

            url += `&sortCol=${config.sort?.column ?? "plant_name"}`;
            url += `&sortDir=${config.sort?.direction ?? "ASC"}`;

            if (config.search) {
                const search = Object.keys(config.search)
                    .filter(key => key !== "seye_type")
                    .map(key => {
                        const value = config.search[key];

                        if (
                            !value ||
                            (Array.isArray(value) && value.length < 1)
                        ) {
                            return "";
                        }

                        return `${key}=${encodeURIComponent(value)}`;
                    })
                    .filter(Boolean)
                    .join("&");

                if (search) {
                    url += `&${search}`;
                }
            }

            return axios
                .get(
                    `${global.config.api_url_v1}${url}`,
                    getHeaders()
                )
                .then(response => ({
                    response,
                    type: item.type,
                    type_name: item.type_name
                }));
        });

        // ESTA LÍNEA ES LA QUE TE FALTA
        const responses = await Promise.all(requests);

        let plants = [];

        responses.forEach(item => {
            const data =
                item.response?.data?.data ??
                item.response?.data;

            if (Array.isArray(data?.plants)) {
                const typedPlants = data.plants.map(plant => ({
                    ...plant,
                    seye_type: item.type,
                    seye_type_name: item.type_name
                }));

                plants = plants.concat(typedPlants);
            }
        });

        const selectedType = config.search?.seye_type;

        if (selectedType) {
            plants = plants.filter(
                plant => plant.seye_type === selectedType
            );
        }

        plants.sort((a, b) => {
            const column = config.sort?.column ?? "plant_name";
            const direction = config.sort?.direction ?? "ASC";

            const valueA = a[column] ?? "";
            const valueB = b[column] ?? "";

            const result = String(valueA).localeCompare(
                String(valueB),
                undefined,
                {
                    numeric: true,
                    sensitivity: "base"
                }
            );

            return direction === "DESC"
                ? -result
                : result;
        });

        const perPage =
            config.pagination?.perPage ?? 20;

        const page =
            config.pagination?.page ?? 1;

        const offset =
            perPage * (page - 1);

        const paginatedPlants = plants.slice(
            offset,
            offset + perPage
        );

        successCallBack({
            data: {
                plants: paginatedPlants,
                total: plants.length
            }
        });

    } catch (error) {
        console.error(
            "Error loading plants for delete:",
            error
        );

        failCallBack();
        commonFailure(error);
    }
}

export function getUserPlantsDataById(id, successCallBack, failCallBack) {
    axios.get( `${global.config.api_url_v1}plant/${id}`, getHeaders())
        .then(function (response) { commonSuccess(response, successCallBack); })
        .catch(function (error) { failCallBack(); commonFailure(error); });
}

export function deleteUserPlant(id, successCallBack, failCallBack) {
    axios.delete( `${global.config.api_url_v1}plant/${id}`, getHeaders())
        .then(function (response) { commonSuccess(response, successCallBack); })
        .catch(function (error) { failCallBack(); commonFailure(error); });
}